import { render } from "./SpreadsheetReviewModal.vue?vue&type=template&id=bfa41068&scoped=true&ts=true"
import script from "./SpreadsheetReviewModal.vue?vue&type=script&lang=ts"
export * from "./SpreadsheetReviewModal.vue?vue&type=script&lang=ts"

import "./SpreadsheetReviewModal.vue?vue&type=style&index=0&id=bfa41068&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa41068"]])

export default __exports__